import { createSlice, createAsyncThunk } from '@reduxjs/toolkit' // 👈️ Redux Imports
import axios from 'axios'// 👈️ Axios Imports
import { urlReportingService } from '@src/endpoints'

export const getCPMonthendReport = createAsyncThunk('cpMonthendReport/getCPMonthendReport', async (param) => {
  const response = await axios.get(`${urlReportingService}/GetCPMonthendReport/${param.date}`)
  return {
    CPMonthendReport: response.data.data,
    loaded: true
  }
})


export const CPMonthendReportSlice = createSlice({
    name: 'CPMonthendReport',
    initialState: {
        loaded : false,
        error : false,
        CPMonthendReport: null
    },
    reducers: {},
    extraReducers: builder => {
        builder
        .addCase(getCPMonthendReport.pending, (state) => {
            state.loaded = false
        })
        .addCase(getCPMonthendReport.fulfilled, (state, action) => {
            state.loaded = action.payload.loaded
            state.CPMonthendReport = action.payload.CPMonthendReport
        })
        .addCase(getCPMonthendReport.rejected, (state) => {
            state.loaded = true
            state.error = true
        })
    }
})

export default CPMonthendReportSlice.reducer